import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Portal from 'utils/portal/Portal';
import { areas } from '../../constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { Typography } from '@totalsoft/rocket-ui';

const NotFound = props => {
  const { t } = useTranslation();
  return (
    <Portal container={props.getElemByAreaKey(areas.header)}>
      <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
        {t(props.title)}
      </Typography>
    </Portal>
  );
};

NotFound.propTypes = {
  title: PropTypes.string,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(React.memo(NotFound));
